module.exports = __webpack_public_path__ + "img/percent_stacked_column.d3b6e4bf.svg";